import AdminSidebarNew, { SidebarProvider, useSidebar } from './AdminSidebarNew';
import { AdminAuraProvider, useAdminAura } from '../context/AdminAuraContext';
import FloatingWorkspaceWidget from './admin/FloatingWorkspaceWidget';

// Admin Layout wrapper component with aura support
const AdminLayoutContent = ({ children }) => {
  const { isCollapsed } = useSidebar();
  const { currentColors } = useAdminAura();
  const primaryColor = currentColors[0] || '#D4AF37';
  
  return (
    <div className="min-h-screen bg-[#0A0A0A] relative">
      {/* Subtle background gradient */}
      <div className="fixed inset-0 bg-gradient-to-br from-[#0A0A0A] via-[#0A0A0A] to-[#0F0F0F] pointer-events-none" />
      
      {/* Decorative aura accent - top right */}
      <div 
        className="fixed top-0 right-0 w-[500px] h-[500px] blur-[120px] rounded-full pointer-events-none transition-colors duration-500" 
        style={{ backgroundColor: `${primaryColor}08` }}
      />
      
      {/* Secondary aura accent - bottom left */}
      <div 
        className="fixed bottom-0 left-0 w-[400px] h-[400px] blur-[100px] rounded-full pointer-events-none transition-colors duration-500" 
        style={{ backgroundColor: `${currentColors[1] || primaryColor}05` }}
      />
      
      <AdminSidebarNew />
      <main 
        className={`relative z-10 transition-all duration-300 ${
          isCollapsed ? 'lg:ml-20' : 'lg:ml-[280px]'
        }`}
      >
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
      
      {/* Floating Workspace Widget - Notes & Chat */}
      <FloatingWorkspaceWidget />
    </div>
  );
};

// Admin Layout with all providers
const AdminLayout = ({ children }) => {
  return (
    <AdminAuraProvider>
      <AdminLayoutContent>{children}</AdminLayoutContent>
    </AdminAuraProvider>
  );
};

// Export everything
export { AdminSidebarNew, SidebarProvider, useSidebar, AdminLayout, useAdminAura };
export default AdminLayout;
